/* @jsx h */
import { useToast } from "@app/vue/providers/Toast";

import { computed, defineComponent, h } from "vue";
import { cancelOrder } from "./helpers";
import { useLocalization } from "@lemmonhq/uikit";
import { OrderCardHeader } from "./OrderCardHeader";
import { OrderCardMain, OrderCardProps } from "./OrderCardMain";
export { OrderCardMain } from "./OrderCardMain";

export const OrderCard = defineComponent<OrderCardProps>({
  name: "OrderCard",
  props: [
    "order",
    "orders",
    "onFoodStatusChange",
    "onOrderCancel",
    "closeOpenOrder",
    "foodTypes",
    "onOrderUpdate",
  ],
  setup(props) {
    const toast = useToast();
    const { t } = useLocalization();

    //    if (!props.order.items) return () => <div />;

    // Create computed properties for reactive values
    const realOrder = computed(() =>
      props.order.parent_id
        ? props.orders.value.find((el) => el.id === props.order.parent_id)
        : props.order,
    );

    const handleCancelOrder = async () => {
      const orderId = realOrder.value?.id;
      if (!orderId) return;

      try {
        const success = await cancelOrder(
          orderId,
          realOrder.value.status,
          props.onOrderCancel,
          t,
        );
        if (success) {
          toast.showToast(t("orders.cancel.success"), {
            type: "success",
            autoHide: 3000,
            icon: "order_approve",
          });
        }
      } catch (error) {
        console.error("Failed to cancel order:", error);
        toast.showToast(t("orders.cancel.failed"), { type: "error" });
      }
    };

    return () => {
      if (!realOrder.value) return null;

      return (
        <div
          data-id={props.order.id}
          data-id2={realOrder.value.id}
          style={{
            background: "var(--order-card-background)",
          }}
          class="l-box-shadow rounded-lg mb-4 break-inside-avoid border text-xs max-h-full flex flex-col select-none overflow-hidden"
        >
          <OrderCardHeader
            order={props.order}
            onCancelOrder={handleCancelOrder}
          />
          <OrderCardMain {...props} />
        </div>
      );
    };
  },
});
